<template>
	<Page>
		<template #header>Create</template>
		<template #default>
			<SeedViewer :phrase="mnemonic" />

			<HintBlock
				><CircleExclamationIcon class="icon" />Using cryptocurrency implies the responsibility of storing it.
				Your seed phrase is stored locally on your device. By continuing, you confirm that you have saved your
				seed phrase ! If telegram resets the cache you will not be able to regain access to your wallet without
				seed phrase. Write down your seed phrase!</HintBlock
			>
		</template>
		<template #footer>
			<BaseCheckbox v-model="saved">I saved seed phrase</BaseCheckbox>

			<!-- <label class="flex f-row select-none">
				<input v-model="saved" type="checkbox" name="checkbox" />
				I saved seed phrase
			</label> -->
			<ButtonMain :disabled="!saved" @click="create()">Create</ButtonMain>
		</template>
	</Page>
</template>

<script setup lang="ts">
import { useWalletStore } from '@/stores/useWalletStore';
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { libs } from '@waves/waves-transactions';
import ButtonMain from '@/components/ui/BaseButton.vue';
import Page from '@/components/ui/Page.vue';
import HintBlock from '@/components/ui/HintBlock.vue';
import CircleExclamationIcon from '@/assets/icons/circle-exclamation.svg?component';
import SeedViewer from '@/components/SeedViewer.vue';
import BaseCheckbox from '@/components/ui/BaseCheckbox.vue';
// import { Buffer } from 'buffer';

const { addWallet } = useWalletStore();
const router = useRouter();
const { query } = useRoute();

const mnemonic = ref(libs.crypto.randomSeed());

const saved = ref(false);

const create = () => {
	addWallet(mnemonic.value);

	if (query.callbackUrl && !Array.isArray(query.callbackUrl))
		router.replace(Buffer.from(query.callbackUrl, 'base64').toString());
	else router.replace('/');
};
</script>
